import * as Sentry from '@sentry/react'
export const SET_ORGANIZATION = 'SET_ORGANIZATION'
export const SET_AVALIABLE_ORGANIZATIONS = 'SET_AVALIABLE_ORGANIZATIONS'

export function setOrganization (org, user) {
  return dispatch => {
    if (org?.id) {
      let teamMemberRole
      if (user?.userId) {
        const member = org?.members?.find(m => m?.UserId === user?.userId)
        teamMemberRole = member?.TeamMemberRole
      }

      Sentry.setContext('Organization', {
        ID: org.id,
        'Organisations Name': org?.organisationsName,
        Email: org?.email,
        'Team member role': teamMemberRole
      })

      Sentry.setTag('organization.id', org.id)
      if (org?.organisationsName) {
        Sentry.setTag('organization.organisationsName', org.organisationsName)
      }
      if (org?.email) {
        Sentry.setTag('organization.email', org.email)
      }
      if (teamMemberRole) {
        Sentry.setTag('organization.teamMemberRole', teamMemberRole)
      }
    }
    dispatch({
      type: SET_ORGANIZATION,
      data: org
    })
  }
}

export function setAvaliableOrganizations (list) {
  return dispatch => {
    dispatch({
      type: SET_AVALIABLE_ORGANIZATIONS,
      data: list
    })
  }
}
